var _path, _path2, _path3, _g, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComtSpecial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H0V14H14V0Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.37922C1 1.45138 1.75216 0.699219 2.68 0.699219H9.48C9.93978 0.699219 10.3795 0.887656 10.6966 1.2206L12.5366 3.1526C12.8341 3.46498 13 3.87983 13 4.31122V11.6192C13 12.5471 12.2478 13.2992 11.32 13.2992H2.68C1.75216 13.2992 1 12.5471 1 11.6192V2.37922Z",
    fill: "#7BDBA6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1265_132339",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 12,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.37922C1 1.45138 1.75216 0.699219 2.68 0.699219H9.50412C9.94969 0.699219 10.377 0.876218 10.6921 1.19128L12.5079 3.00716C12.823 3.32222 13 3.74953 13 4.1951V11.0192C13 11.9471 12.2478 12.6992 11.32 12.6992H2.68C1.75216 12.6992 1 11.9471 1 11.0192V2.37922Z",
    fill: "#7BDBA6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1265_132339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.80078 -1.7998L15.8008 4.2002H11.0008C10.338 4.2002 9.80078 3.66294 9.80078 3.0002V-1.7998Z",
    fill: "#BAECD1"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35938 4.47949H7.71937",
    stroke: "#EAFFF4",
    strokeWidth: 1.4028,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35938 6.99902H10.2394",
    stroke: "#EAFFF4",
    strokeWidth: 1.4028,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35938 9.51855H10.2394",
    stroke: "#EAFFF4",
    strokeWidth: 1.4028,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComtSpecial);
export default __webpack_public_path__ + "static/media/comt_special.cfcddc7ba4f64ff243017732cc8c2232.svg";
export { ForwardRef as ReactComponent };